import { registerEnumType } from 'type-graphql'

export enum ViewCountKeyEnum {
  Order = 'Order',
  PurchaseOrder = 'PurchaseOrder',
  Logistic = 'Logistic',
  Customer = 'Customer',
  Product = 'Product',
  Project = 'Project',
  Task = 'Task',
  WorkOrder = 'WorkOrder',
}

// Register as GraphQL enum
registerEnumType(ViewCountKeyEnum, {
  name: 'ViewCountKeyEnum',
  description: 'Entity types that support view count tracking',
})
